document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(document).ready(function () {
	const header = $("header");
	const menuControl = $("#menuControl");
	const mobileLocaleControl = $("#mobileLocaleControl");
	const mobileLocaleMenu = $("#mobileLocaleMenu");
	const desktopLocaleControl = $("#desktopLocaleControl");
	const desktopLocaleMenu = $("#desktopLocaleMenu");
	const body = $("body");

	mobileLocaleControl.click(() => {
		mobileLocaleMenu.toggleClass("hidden");
	});

	desktopLocaleControl.click(() => {
		desktopLocaleMenu.toggleClass("hidden");
	});

	menuControl.click(() => {
		header.toggleClass("active");

		if (header.hasClass("active")) {
			const scrollTop = $(window).scrollTop();
			body.addClass("no-scroll").css('top', `-${scrollTop}px`).data("scrollTop", scrollTop);
		} else {
			const scrollTop = body.data("scrollTop");
			body.removeClass("no-scroll").css('top', '');
			$(window).scrollTop(scrollTop);
		}
	});
});

$(document).ready(function () {
	const $toggleLinks = $('a[data-toggle]');

	if (!$toggleLinks.length) {
		return;
	}

	$toggleLinks.click(function (event) {
		event.preventDefault();

		const targetList = $(this).data('toggle');
		const target = $('#' + targetList);
		const isVisible = !target.hasClass('hidden');

		target.toggleClass('hidden');

		if (isVisible) {
			$(this).addClass('hidden');
			$(this).siblings('a[data-toggle]').removeClass('hidden');
		} else {
			$(this).addClass('hidden');
			$(this).siblings('a[data-toggle]').removeClass('hidden');
		}
	});
});